var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TextField } from "@material-ui/core";
import PythonError from "./PythonError";
var StyledConsole = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: pre-wrap;\n"], ["\n  white-space: pre-wrap;\n"])));
var StyledUserInput = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #efefef;\n  border-radius: 3px 3px 3px 3px;\n  color: #292929;\n  margin: 3px;\n  padding: 3px;\n"], ["\n  background-color: #efefef;\n  border-radius: 3px 3px 3px 3px;\n  color: #292929;\n  margin: 3px;\n  padding: 3px;\n"])));
var Console = function (props) {
  var inputRequested = props.inputRequested,
    outputContent = props.outputContent,
    scrollToBottom = props.scrollToBottom,
    sendInput = props.sendInput;
  var t = useTranslation()[0];
  var userInputFieldRef = React.createRef();
  var focusOnInputField = function () {
    var _a;
    (_a = userInputFieldRef === null || userInputFieldRef === void 0 ? void 0 : userInputFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  };
  useEffect(function () {
    scrollToBottom();
    if (inputRequested) {
      focusOnInputField();
    }
  }, [inputRequested, outputContent]);
  var keyPressOnInput = function (e) {
    if (e.key === "Enter" && inputRequested) {
      sendInput(e.target.value);
    }
  };
  var outputMapper = function (output) {
    switch (output.type) {
      case "input":
        return React.createElement(StyledUserInput, {
          key: output.id
        }, output.text);
      case "error":
        return React.createElement(PythonError, {
          key: output.id,
          error: output.text,
          trace: output.traceback
        });
      default:
        return React.createElement(React.Fragment, {
          key: output.id
        }, output.text);
    }
  };
  return React.createElement(StyledConsole, null, React.createElement("pre", {
    style: {
      whiteSpace: "pre-wrap",
      wordWrap: "break-word"
    }
  }, outputContent.map(outputMapper)), inputRequested && React.createElement(TextField, {
    inputRef: userInputFieldRef,
    label: t("enterInputAndPressEnter"),
    margin: "dense",
    variant: "outlined",
    InputLabelProps: {
      shrink: true
    },
    onKeyPress: keyPressOnInput,
    style: {
      display: "block"
    },
    "data-cy": "user-input-field"
  }));
};
export default Console;
var templateObject_1, templateObject_2;